module.exports = __webpack_public_path__ + "static/blockchain_integration-7170c4e87e4a6088c9c266f38069e0fa.png";